import { TransState } from './trans-state.enum';
import { TransType } from './trans-type.enum';


/**
 * è½¬ç 
 */
export class Trans {
  /**
   * å°é¢æªå¾key
   */
  coverKey?: string;
  /**
   * æºæä»¶key
   */
  rawKey: string;
  /**
   * è½¬ç ç±»å
   */
  type: TransType;
  /**
   * Failç¶æä¼åå«éè¯¯ä¿¡æ¯
   */
  message: string;
  /**
   * è½¬ç ç¶æ
   */
  state: TransState;
  /**
   * è½¬ç æ¶é¿
   */
  duration: number;
}
